import { Box, Typography } from '@mui/material';

export const PageTitle = ({ title }: { title: string }) => (
    <Box sx={{ mt: 6, mb: 4 }}>
        <Typography variant="h1" gutterBottom data-testid="page-title">
            {title}
        </Typography>
    </Box>
);
